import { DAILY_STATISTIC_PRESENTATION } from '@features/statistics/constants'
import type { DailyStatistic } from '@features/statistics/types'

/**
 * Применяет presentation-настройки к элементу ежедневной статистики.
 *
 * @param statistic - статистика из доменной модели
 * @param index - позиция статистики в backend-ответе
 * @returns оформленная статистика либо `null` для скрытых позиций
 */
export const formatDailyStatistic = (
  statistic: DailyStatistic,
  index: number,
): DailyStatistic | null => {
  const presentation = DAILY_STATISTIC_PRESENTATION[index]

  if (presentation === null) return null

  return {
    ...statistic,
    ...presentation,
  }
}
